<thead>
  <tr class="days-of-the-week">
    <% dayNames.forEach(function(name) { %>
      <th class="day"><%- name %></th>
    <% }) %>
  </tr>
</thead>
<tbody>
<% days.forEach(function(day, index) { %>
  <% if (index % 7 == 0) { %>
  <tr class="week">
  <% } %>
    <td
      data-date="<%- day.date %>"
      data-day-available="<%= day.slots.length > 0 %>"
      class="day <%- classNames({ 'day-availability-available': day.slots.length, focus: day.focus, 'current-month': day.currentMonth, 'other-month': !day.currentMonth }) %>"
      data-slot-count="<%= day.slots.length %>"
      <% if (day.slots.length) { %>
      data-analytics-element="slot-picker-calendar-day" data-analytics-interaction="click" data-analytics-value="<%- day.date %>"
      <% } %>
    >
      <span class="day-meta">
        <span class="day-title">
          <%= moment(day.date).format('D') %>
        </span>
      </span>
    </td>
  <% if (index % 7 == 6 || days.length == index + 1) { %>
  </tr>
  <% } %>
<% }) %>
</tbody>
